<div class="content-block">

  <div class="content-header">
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h2 class="content-block">Consegne effettuate</h2>
          <div class="d-flex gap-4">
            <app-btn-nuova-consegna></app-btn-nuova-consegna>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card primary">

    <div class="card-body">
      <div class="row">
        <div class=" col-12 col-md-6 col-lg-3">
          <div class="dx-fieldset-header">Dipendente</div>
          <dx-lookup #dipendente displayExpr="nominativo" valueExpr="id" [searchEnabled]="true" [searchTimeout]="500"
            [items]="listDip" placeholder="Tutti" clearButtonText="Tutti" [showClearButton]="true"
            (onValueChanged)="dipendenteSelected($event)">
          </dx-lookup>
        </div>
        <div class=" col-12 col-md-6 col-lg-3">
          <div class="dx-fieldset-header">Da data</div>
          <dx-date-box #dadata displayFormat="dd/MM/yyyy" [(value)]="daData" (onValueChanged)="controlloDaData()">
            >
          </dx-date-box>
        </div>
        <div class=" col-12 col-md-6 col-lg-3">

          <div class="dx-fieldset-header">A data</div>
          <dx-date-box #adata displayFormat="dd/MM/yyyy" [(value)]="aData" (onValueChanged)="controlloAData()">
          </dx-date-box>
        </div>
        <div class=" col-12 col-md-6 col-lg-3">
          <dx-button stylingMode="contained" icon="search" text="Cerca" type="normal" width="120" type="success"
            style="margin-top:32px;" (onClick)="onSearchClick()">
          </dx-button>
        </div>
      </div>
      @if (dataSource) {
      <div class="row">
        <div class="col-12">
          <div class="btn-group">
            <dx-button id="exportDocConsegnaZip" style="margin:5px;" icon="fa fa-file-archive-o" stylingMode="contained"
              type="success" text="Esporta archivio documenti" (onClick)="exportDocConsegnaZip()">
            </dx-button>
            <dx-button id="exportDocConsegnaPDF" style="margin:5px;" icon="exportpdf" stylingMode="contained"
              type="success" text="Esporta documenti consegna" (onClick)="exportDocConsegnaPDF()">
            </dx-button>
            @if (dipSelezionato) {
            <dx-button id="exportButton" style="margin:5px;" icon="exportpdf" stylingMode="contained" type="success"
              text="Esporta Movimenti {{selectedDip?.nominativo}}" (onClick)="exportDataPDF()">
            </dx-button>
            }
          </div>
          <dx-data-grid #gridMovDipendente [dataSource]="dataSource" [showBorders]="true" [columnAutoWidth]="true"
            [columnHidingEnabled]="true" (onInitNewRow)="onInitNewRow()" (onExporting)="onExporting($event)"
            (onRowRemoved)="onRowRemoved()" (onRowUpdating)="onRowUpdating($event)"
            [masterDetail]="{ enabled: true, template: 'detail' }">
            <dxo-export [enabled]="true"></dxo-export>
            <dxo-editing mode="popup" [allowAdding]="true" [allowDeleting]="true" [useIcons]="true">
              <dxo-texts confirmDeleteMessage="Confermare la cancellazione?"></dxo-texts>
            </dxo-editing>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager [showPageSizeSelector]="true" [showInfo]="true"></dxo-pager>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxi-column type="buttons" [buttons]="['edit', 'delete']"></dxi-column>
            <dxi-column name="fileOptions" [formItem]="{ visible: false }" [allowFiltering]="false"
              [allowSorting]="false" cellTemplate="scaricaPDF" alignment="center" width="30" caption="">
            </dxi-column>
            <div *dxTemplate="let d of 'scaricaPDF'">
              @if (d.data.firmato && d.data.allegato != null) {
                <i class="dx-icon-pdffile" (click)="scaricaFile(d.data)" data-toggle="tooltip" data-placement="top"
                  title="Scarica documento"></i>
              }
            </div>
            <dxi-column name="addFileAllegato" [formItem]="{ visible: false }" [allowFiltering]="false"
              [allowSorting]="false" cellTemplate="aggiungiAllegatoTemplate" [allowEditing]="false" alignment="center"
              width="30" caption="">
            </dxi-column>
            <div *dxTemplate="let d of 'aggiungiAllegatoTemplate'">
              <i (click)="newAllegatoClick(d.data)" style="cursor: pointer;" class="dx-icon-upload"
                data-toggle="tooltip" data-placement="top" title="Aggiungi allegato"></i>
            </div>
            <dxi-column dataField="id" [visible]="false">
            </dxi-column>
            <dxi-column dataField="progr">
            </dxi-column>
            @if (!dipSelezionato) {
            <dxi-column dataField="idDipendente" caption="Dipendente">
              <dxo-lookup [dataSource]="listDip" valueExpr="id" [displayExpr]="getDipendenteDisplayExpr"></dxo-lookup>
            </dxi-column>
            }
            <dxi-column dataField="idArticolo" caption="Articolo">
              <dxo-lookup [dataSource]="listArticoli" valueExpr="id"
                [displayExpr]="getArticoloDisplayExpr"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="idMansione" caption="Mansione">
              <dxo-lookup [dataSource]="listMansioni" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="idReparto" caption="Reparto">
              <dxo-lookup [dataSource]="listReparti" valueExpr="id" displayExpr="descrizione"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="idResponsabile" caption="Responsabile">
              <dxo-lookup [dataSource]="listDip" valueExpr="id" displayExpr="nominativo"></dxo-lookup>
            </dxi-column>
            <dxi-column dataField="data" format="dd/MM/yyyy" dataType="date" [sortIndex]="1" sortOrder="desc">
            </dxi-column>
            <dxi-column dataField="qta">
            </dxi-column>
            <dxi-column dataField="cambio" dataType="boolean" [visible]="true">
            </dxi-column>
            <dxi-column caption="Restituito precedente" name="cambioString" [formItem]="{ visible: false }"
              [allowFiltering]="false" [allowSorting]="false" cellTemplate="restituitoPrecedenteTemplate"
              [visible]="false">
            </dxi-column>
            <div *dxTemplate="let d of 'restituitoPrecedenteTemplate'">
              @if (d.data.cambio) {
              <span>Sì</span>
              }
              @if (!d.data.cambio) {
              <span>No</span>
              }
            </div>
            <dxi-column dataField="dettagli" [visible]="false">
            </dxi-column>
            <dxi-column dataField="firmato" dataType="boolean" [visible]="false">
            </dxi-column>
            <div *dxTemplate="let mov of 'detail'">
              <div class="master-detail-caption">{{"Allegati del movimento " + mov.data.progr}}</div>
              <app-detail-allegati-mov [idMov]="mov.data.id"></app-detail-allegati-mov>
            </div>
          </dx-data-grid>
        </div>
      </div>
      }
    </div>
  </div>

</div>


<dx-load-panel #loadPanel shadingColor="rgba(0,0,0,0.4)" [(visible)]="loadPanelVisible" [showIndicator]="true"
  [showPane]="true" [shading]="true" [hideOnOutsideClick]="false">
</dx-load-panel>

@if (movRif) {
<app-popup-new-allegato-movimenti [mov]="movRif"
  (popupNewAllegatoMovimentiEventEmitter)="onPopupNewAllegatoMovimentiEvent($event)"></app-popup-new-allegato-movimenti>
}